import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Profile from './Profile';
import ResourceGrid from './ResourceGrid';
import Breadcrumb from "./BreadcrumbsComponent";
import { Container, Grid } from "@material-ui/core";
import api, {consoleDevLog} from "../apiConfig";

const ClientResources = () => {
  const { id } = useParams();
  
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [cmas, setCmas] = useState([]); // <--- New state for CMAs

  useEffect(() => {
    fetchClientData();
    fetchClientCMAs(); // <--- Also fetch CMAs here
  }, [id]);

  // Fetch the client data (existing logic)
  const fetchClientData = async () => {
    try {
      const response = await api.get(`/clients/${id}`);
      const data = response.data;
      setFirstName(data.firstName);
      setLastName(data.lastName);
    } catch (error) {
      console.error("Error fetching client data:", error);
    }
  };

  // Fetch all CMAs, then filter to those that match this client’s ID
  const fetchClientCMAs = async () => {
    consoleDevLog("Fetching CMAs for client ID:", id);
    try {
      const response = await api.get(`/cma`); // or an endpoint like `/cma?clientId=${id}`
      const allCmas = response.data;
      
      // Filter down to only this client's CMAs 
      // (only if you've stored the actual client id in `cma.clientId`)
      const filteredCmas = allCmas.filter((cma) => cma.clientId === id);
      consoleDevLog(filteredCmas);
      setCmas(filteredCmas);
    } catch (error) {
      console.error("Error fetching CMAs:", error);
    }
  };

  return (
    <Container>
      <Grid container spacing={3}>
        <Breadcrumb />
      </Grid>

      <div style={{marginBottom: "30px"}}></div>
      
      <div>
        <Profile
          firstName={firstName}
          lastName={lastName}
          email={`${firstName.toLowerCase()}.${lastName.toLowerCase()}@example.com`}
          phone="123-456-7890"
        />

        {/*<ResourceGrid title={`${firstName}’s Preferences`} id={id} />*/}

        <div className="divider"></div>

        {/*
          Pass the filtered cmas into ResourceGrid
          For example, your ResourceGrid might take a prop like
          "data" or "items" to display
        */}
        <ResourceGrid title={`${firstName}’s CMAs`} data={cmas} id={id}/>

        {/*<ResourceGrid title={`${firstName}’s Reports`} id={id} />*/}
      </div>
    </Container>
  );
};

export default ClientResources;
